( function () {
  'use strict';

  var GSAP = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  var SCROLL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

  var reduced =
    window.matchMedia &&
    window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

  function loadScript( src ) {
    return new Promise( function ( resolve, reject ) {
      if ( document.querySelector( 'script[src="' + src + '"]' ) ) {
        resolve();
        return;
      }
      var el = document.createElement( 'script' );
      el.src = src;
      el.async = true;
      el.onload = resolve;
      el.onerror = reject;
      document.head.appendChild( el );
    } );
  }

  function setupPatternPickers( root, buttons, body, badge, sid, cap ) {
    if ( ! buttons.length || ! body || ! sid ) {
      return;
    }
    var labels = { heritage: 'P.A.T.', grid: 'Grid', plaid: 'Plaid' };
    buttons.forEach( function ( btn ) {
      btn.addEventListener( 'click', function () {
        var key = btn.getAttribute( 'data-pattern' );
        if ( ! key ) {
          return;
        }
        body.setAttribute( 'fill', 'url(#hero-cap-pattern-' + key + '-' + sid + ')' );
        if ( badge && labels[ key ] ) {
          badge.textContent = labels[ key ];
        }
        buttons.forEach( function ( b ) {
          var on = b === btn;
          b.classList.toggle( 'is-active', on );
          b.setAttribute( 'aria-pressed', on ? 'true' : 'false' );
        } );
        if ( cap ) {
          cap.classList.remove( 'hero-motion__cap-wrap--nudge' );
          void cap.offsetWidth;
          cap.classList.add( 'hero-motion__cap-wrap--nudge' );
        }
      } );
    } );
  }

  function setupPointerParallax( root, cap ) {
    if ( ! cap || reduced ) {
      return;
    }
    var raf = 0;
    var targetY = 0;
    var targetX = 0;
    var currentY = 0;
    var currentX = 0;

    function tick() {
      currentX += ( targetX - currentX ) * 0.18;
      currentY += ( targetY - currentY ) * 0.18;
      cap.style.transform =
        'perspective(800px) rotateY(' + currentX + 'deg) rotateX(' + currentY + 'deg)';
      raf = requestAnimationFrame( tick );
    }

    root.addEventListener( 'mousemove', function ( e ) {
      var bounds = root.getBoundingClientRect();
      var x = ( e.clientX - bounds.left ) / bounds.width - 0.5;
      var y = ( e.clientY - bounds.top ) / bounds.height - 0.5;
      targetX = x * 12;
      targetY = -y * 8;
      if ( ! raf ) {
        raf = requestAnimationFrame( tick );
      }
    } );

    root.addEventListener( 'mouseleave', function () {
      targetX = 0;
      targetY = 0;
    } );
  }

  function setupScrollMotion( root, pin, cap, patterns, hint ) {
    if ( typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' ) {
      return;
    }
    gsap.registerPlugin( ScrollTrigger );
    root.classList.add( 'hero-motion--scroll-ready' );

    gsap.timeline( {
      scrollTrigger: {
        trigger: root,
        start: 'top top',
        end: '+=110%',
        scrub: 0.75,
        pin: pin,
        anticipatePin: 1,
      },
    } )
      .to( patterns[ 0 ], { x: '-6%', y: '-4%', rotate: 6, scale: 1.06, duration: 1 }, 0 )
      .to( patterns[ 1 ], { x: '8%', y: '6%', rotate: -8, scale: 1.1, duration: 1 }, 0 )
      .to( cap, { y: -24, scale: 1.04, duration: 1 }, 0 )
      .to( hint, { opacity: 0, duration: 0.2 }, 0.15 );
  }

  function lazyLoadScrollMotion( root, pin, cap, patterns, hint ) {
    var started = false;

    function start() {
      if ( started || reduced ) {
        return;
      }
      started = true;
      loadScript( GSAP )
        .then( function () {
          return loadScript( SCROLL );
        } )
        .then( function () {
          setupScrollMotion( root, pin, cap, patterns, hint );
        } )
        .catch( function () {
          /* scroll chapter is optional */
        } );
    }

    root.addEventListener( 'wheel', start, { once: true, passive: true } );
    root.addEventListener( 'touchstart', start, { once: true, passive: true } );

    if ( 'requestIdleCallback' in window ) {
      window.requestIdleCallback( start, { timeout: 2500 } );
    } else {
      window.setTimeout( start, 2000 );
    }
  }

  function initHeroMotion( root ) {
    var pin = root.querySelector( '.hero-motion__pin' );
    var cap = root.querySelector( '[data-hero-cap]' );
    var capBody = root.querySelector( '[data-hero-cap-body]' );
    var code = root.querySelector( '[data-hero-code]' );
    var hint = root.querySelector( '[data-hero-hint]' );
    var patterns = root.querySelectorAll( '.hero-motion__pattern' );
    var pickers = root.querySelectorAll( '[data-hero-pickers] .hero-motion__pick' );
    var sectionId = root.getAttribute( 'data-section-id' ) || '';

    setupPatternPickers( root, pickers, capBody, code, sectionId, cap );
    setupPointerParallax( root, cap );

    if ( reduced || ! pin ) {
      root.classList.add( 'hero-motion--static' );
      return;
    }

    lazyLoadScrollMotion( root, pin, cap, patterns, hint );
  }

  document.addEventListener( 'DOMContentLoaded', function () {
    document.querySelectorAll( '[data-hero-motion]' ).forEach( initHeroMotion );
  } );
}() );
